import React, {useCallback, useState} from "react";
import "./NumberInput.scss";
import Maths from "oc-modules/oc-commons/Maths";
import classnames from "classnames";

export const useNumberInputPart = ({
                                       value,
                                       setValue,
                                       step,
                                       min,
                                       max,
                                       inputScale,
                                       decimals,
                                       slider
                                   }) => {
    inputScale = inputScale ?? 1;
    min = Maths.isFinite(min) ? min * inputScale : Number.NEGATIVE_INFINITY;
    max = Maths.isFinite(max) ? max * inputScale : Number.POSITIVE_INFINITY;
    decimals = decimals ?? 4;
    step = (step ?? Math.max(Math.abs(max - min) / 1000) * inputScale , decimals == 0 ? 0 : Math.pow(0.1, decimals));
    const floatVal = (value ?? 0) * inputScale;
    const floatStr = parseFloat(floatVal.toFixed(decimals)).toString();
    const [strVal, _setStrVal] = useState(floatStr);
    const setStrVal = (str) => {
        _setStrVal(str);
        const float = parseFloat(str) / inputScale;
        let value = Maths.isFinite(float) ? float : 0;
        value = Math.max(min, value);
        value = Math.min(max, value);
        setValue(value);
    };
    const handleBlur = useCallback((e) => {
        setStrVal(floatStr);
    }, [floatStr]);
    return {
        step,
        min,
        max,
        inputScale,
        decimals,
        value,
        setValue,
        floatVal,
        floatStr,
        strVal,
        setStrVal,
        handleBlur,
        numberInput: (<input
            type="text"
            value={strVal}
            className={classnames(!slider && "flex-grow-1")}
            onChange={e => setStrVal(e.target.value)}
            onBlur={handleBlur}
        />),
    };
}

export const NumberInput = ({property}) => {
    const {inputScale, min, max, step, floatVal, setStrVal, numberInput} = useNumberInputPart({
        ...property,
        value: property.get(),
        setValue: v => {
            property.set(v);
            APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
        },
    });
    const minSlider = (Maths.isFinite(min) ? min : -10 * inputScale);
    const maxSlider = (Maths.isFinite(max) ? max : +10 * inputScale);
    return (
        <div className={classnames("number-input flex-row", property.slider && 'with-slider')}>
            {numberInput}
            {property.slider && (
                <input
                    type="range"
                    className="flex-grow-1"
                    min={minSlider}
                    max={maxSlider}
                    step={step}
                    value={floatVal}
                    onChange={e => setStrVal(e.target.value)}
                />
            )}
        </div>
    );
}

